import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=174701fa&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174701fa",
  null
  
)

export default component.exports